import { render, staticRenderFns } from "./bo-tab.vue?vue&type=template&id=294948e6"
import script from "./bo-tab.vue?vue&type=script&lang=js"
export * from "./bo-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports